export default __webpack_public_path__ + "0a3234084fc2f1edbd83999ff725e67d.svg";